import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, Fragment, useEffect, useRef, forwardRef } from 'react';
import AddressFormComponent from '../../elements/address-lookup';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var AddressHistory = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var lookup = _ref.lookup,
      label = _ref.label,
      name = _ref.name,
      _ref$minimumRequiredY = _ref.minimumRequiredYears,
      minimumRequiredYears = _ref$minimumRequiredY === void 0 ? 3 : _ref$minimumRequiredY,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      error = _ref.error,
      formVariant = _ref.formVariant;

  var _useState = useState([{}]),
      _useState2 = _slicedToArray(_useState, 2),
      addresses = _useState2[0],
      setAddresses = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentYears = _useState4[0],
      setCurrentYears = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      lastChanged = _useState6[0],
      setLastChanged = _useState6[1];

  var handleAddressChange = function handleAddressChange(key, address) {
    setAddresses(function (currAddresses) {
      return currAddresses.map(function (addr, index) {
        if (key === index) {
          if (addr.yearsAtAddress !== address.yearsAtAddress) {
            setLastChanged(key);
          }

          return address;
        } else {
          return addr;
        }
      });
    });
  };

  useEffect(function () {
    onChange(addresses);
    setCurrentYears(addresses.reduce(function (prev, addr) {
      return prev + parseInt(addr.yearsAtAddress || 0);
    }, 0));
  }, [addresses]);
  var firstUpdate = useRef(true);
  useEffect(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (lastChanged === addresses.length - 1 && currentYears < minimumRequiredYears) {
      setAddresses(function (prevAddrs) {
        return [].concat(_toConsumableArray(prevAddrs), [{}]);
      });
    } else if (currentYears >= minimumRequiredYears) {
      setAddresses(function (prevAddrs) {
        return prevAddrs.slice(0, lastChanged + 1);
      });
    }
  }, [currentYears]);
  return _jsxs(Fragment, {
    children: [_jsx("input", {
      type: "hidden",
      id: "addressData",
      name: name,
      ref: ref,
      value: JSON.stringify(addresses)
    }), addresses.map(function (_, index) {
      return _jsx(AddressFormComponent, {
        label: label,
        id: index,
        lookup: lookup,
        onChange: handleAddressChange,
        error: error,
        formVariant: formVariant,
        hasTimeAtAddress: true
      }, index);
    })]
  });
});
export default AddressHistory;
//# sourceMappingURL=index.js.map